export default class Header {
    constructor() {
        this.header = document.querySelector(".l-header");
        this.threshold = 10;

        this.init();
    }

    init() {
        if (!this.header) return;

        this.eventBind();
        this.update();
        this.initLanguageTransition();
    }

    initLanguageTransition() {
        const language = this.header.querySelector(".l-header__language[href]");
        if (!language) return;

        const storageKey = "kinioto-language-transition";
        const selected = language.dataset.selected;
        const root = document.documentElement;

        language.addEventListener("click", (event) => {
            if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            if (language.target && language.target !== "_self") return;

            const destination = new URL(language.href, location.href);
            if (destination.origin !== location.origin) return;

            try {
                sessionStorage.setItem(storageKey, JSON.stringify({
                    from: selected,
                    pathname: destination.pathname,
                    timestamp: Date.now(),
                }));
            } catch (error) {
                // リンクの遷移はそのまま続行する
            }
        });

        if (!root.dataset.languageFrom) return;

        const play = () => {
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    delete root.dataset.languageFrom;
                });
            });
        };

        if (document.readyState === "complete") {
            play();
        } else {
            window.addEventListener("load", play, { once: true });
        }

        window.addEventListener("pageshow", (event) => {
            if (event.persisted) {
                delete root.dataset.languageFrom;
            }
        });
    }

    eventBind() {
        window.addEventListener("scroll", () => this.update(), { passive: true });

        const desktopQuery = window.matchMedia("(min-width: 1081px)");
        desktopQuery.addEventListener("change", (event) => {
            if (event.matches) this.closeNav();
        });

        document.querySelectorAll(".js-nav-open").forEach((el) => {
            el.addEventListener("click", () => this.openNav());
        });

        document.querySelectorAll(".js-nav-close").forEach((el) => {
            el.addEventListener("click", () => this.closeNav());
        });

        document.querySelectorAll(".l-navSp__link").forEach((el) => {
            el.addEventListener("click", () => this.closeNav());
        });
    }

    update() {
        const scrolled = (window.scrollY || document.documentElement.scrollTop) > this.threshold;
        this.header.classList.toggle("-scrolled", scrolled);
    }

    openNav() {
        document.body.classList.add("-navopen");
    }

    closeNav() {
        document.body.classList.remove("-navopen");
    }
}
